import React from "react";
import { SettingDisqualifyReason } from "@rankmi/ats-app";

const ApplicantDiscardReasons = () => {
  return <SettingDisqualifyReason />;
};

export default ApplicantDiscardReasons;
